import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Paper, Typography } from '@mui/material';
import * as Server from "./Server.js"
import CircularProgress from '@mui/material/CircularProgress';
import {label} from './Dictionary.js';

function ImagineDialog({open, handleSubmit, handleClose, showImageCount, OKButtonTitle}) {


    const [ImageCount, setImageCount] = React.useState(25);
    const [defaultPrompt, setDefaultPrompt] = React.useState("");    
    const [previewLoading, setPreviewLoading] = React.useState(false)
    const searchParams = new URLSearchParams(document.location.search);

    React.useEffect(() => {
        setDefaultPrompt(localStorage.getItem("last_prompt"))
    }, []);

    function updateImageCount(event) {
        setImageCount(event.target.value)
    }

    function clearPrompt() {
        let elem = document.getElementById("prompt-text")
        elem.value = ""
        elem.focus()
    }

    function updatePreview() {
        let prompt = document.getElementById("prompt-text").value
        if (prompt!="") {
            localStorage.setItem("last_prompt", prompt)
            setDefaultPrompt(prompt)
            let image = document.getElementById("preview_image")
            image.src = "blank.gif"
            setPreviewLoading(true)
            document.getElementById("info_area").innerHTML = ""
            Server.GetImaginePreview(searchParams.get("device_id"), prompt)
            .then((res) => {
                image.onload = () => {
                    setPreviewLoading(false)
                    image.onload = null
                }
                image.src = res.data.url
            }).catch((err) => {
                document.getElementById("info_area").innerHTML = err.response.data.message
                setPreviewLoading(false)
            })
        }
    }

    return (
        <>
        <Dialog
            open={open}
            fullScreen
            onClose={handleClose}
            PaperProps={{
            component: 'form',
            onSubmit: (event) => {
                event.preventDefault();
                const formData = new FormData(event.currentTarget);
                const formJson = Object.fromEntries(formData.entries());
                const prompt = formJson.prompt;
                localStorage.setItem("last_prompt", prompt)
                setDefaultPrompt(prompt)
                handleSubmit(prompt, ImageCount);
                handleClose();
            },
            }}
        >
            <DialogTitle>{label("ID_AIImageGeneration")}</DialogTitle>
            <DialogContent>
            <FormControl sx={{ marginTop: 1 }} fullWidth variant="outlined">
            <InputLabel htmlFor="prompt-text">{label("ID_DescribeYourImage")}</InputLabel>    
            <OutlinedInput
                autoFocus
                required
                multiline
                margin="dense"
                name="prompt"
                id="prompt-text"
                type="text"
                label={label("ID_DescribeYourImage")}
                defaultValue={defaultPrompt}
                startAdornment={<InputAdornment position="start"></InputAdornment>}
                endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={clearPrompt}
                        edge="end"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </InputAdornment>
                  }                
            />
            </FormControl>

            { showImageCount ? (
                <Paper sx={{ marginTop: 3, padding: 1, position: "relative", display: "flex", justifyContent: "center" }}  onClick={updatePreview}>
                { previewLoading ? (
                    <CircularProgress sx={{position: "absolute", top: "50%",  marginTop: "-25px"}}/>
                ) : (
                    <></>
                )}
                <Typography id="info_area" sx={{position: "absolute", top: "50%",  marginTop: "-15px"}}>{label("ID_TapForPreview")}</Typography>
                <img src="blank.gif" id="preview_image" style={{ height: 256, width:256 }}/>
                </Paper>
            ) : (
                <></>
            )}

            { showImageCount ? (
                <FormControl sx={{ marginTop: 4 }} fullWidth>
                <InputLabel id="image-count-select-label">{label("ID_NumberOfImagesToGenerate")}</InputLabel>
                <Select
                labelId="image-count-select-label"
                id="image-count-select"
                value={ImageCount}
                label={label("ID_NumberOfImagesToGenerate")}
                onChange={updateImageCount}
                >
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
                <MenuItem value={365}>365</MenuItem>
                <MenuItem value={-1}>Unlimited</MenuItem>
                </Select>
            </FormControl>
            ) : (
                <></>
            )}

            </DialogContent>
            <DialogActions sx={{ position: 'fixed', backgroundColor:`white`, height:120, bottom: 0, left: 0, right: 0 }}>
            <Button variant="contained" onClick={handleClose}>{label("ID_Cancel")}</Button>
            <Button variant="contained" type="submit">{OKButtonTitle}</Button>
            </DialogActions>
        </Dialog>
        </>
    );

}

export default ImagineDialog;